export default __webpack_public_path__ + "static/media/nav-icon.4b0e27b2.svg";